import {css} from '@emotion/react'
import {useState} from 'react'
import VanishLogo from './VanishLogoA'
import QrModal from './QrModal'
import {getLinkData} from './qrCodeHelpers'
import {EVENTS, logDplWithAppParams} from '../../../util/dpl'

const translations = {
    en: {
        cta: 'Get the app',
    },
    fr: {
        cta: 'Télécharger l’app',
    },
    de: {
        cta: 'App herunterladen',
    },
    nl: {
        cta: 'Download de app',
    },
}

const buttonStyles = css`
    border-radius: 14px;
    background: var(--button, #8519b4);
    padding: 12px 24px;
    cursor: pointer;
    &:hover {
        background: #8f17cb;
    }
`

const textStyles = css`
    color: var(--text-primary, #f2f3fb);
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

const MobileAppCta = ({href, onClick, languageCode = 'en'}) => {
    const text = translations[languageCode] || translations.en
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            css={css`
                ${buttonStyles}
                text-decoration: none;
                display: block;
            `}
            onClick={onClick}
        >
            <p css={textStyles}>{text.cta}</p>
        </a>
    )
}

const DesktopAppCta = ({onClick, languageCode = 'en'}) => {
    const text = translations[languageCode] || translations.en
    return (
        <div
            css={buttonStyles}
            role="button"
            onClick={onClick}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    onClick()
                }
            }}
        >
            <p css={textStyles}>{text.cta}</p>
        </div>
    )
}

const TopBar = ({languageCode = 'en', isMobileDevice = false, showTopBar = false, os, experiment}) => {
    const [showModal, setShowModal] = useState(false)
    const linkData = getLinkData()
    return (
        <div
            css={css`
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                z-index: 1000;
                background: #000;
                padding: 20px;
                display: flex;
                justify-content: center;
                opacity: ${showTopBar ? 1 : 0};
                pointer-events: ${showTopBar ? 'auto' : 'none'};
                transition: opacity 0.2s ease-in-out;
            `}
        >
            {showModal && <QrModal languageCode={languageCode} setShowModal={setShowModal} />}
            <div
                css={css`
                    max-width: 1000px;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                `}
            >
                <VanishLogo
                    css={css`
                        width: 127px;
                    `}
                />
                {isMobileDevice ? (
                    <MobileAppCta
                        href={linkData.link}
                        onClick={() => {
                            logDplWithAppParams(EVENTS.StartpageAppCtaClick, {
                                os,
                                type: 'cta-banner',
                                experiment,
                                source: linkData.source,
                            })
                        }}
                        languageCode={languageCode}
                    />
                ) : (
                    <DesktopAppCta onClick={() => setShowModal(true)} languageCode={languageCode} />
                )}
            </div>
        </div>
    )
}

export default TopBar
